import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c80113a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "vue-curriculum-component" }
const _hoisted_2 = { class: "tl-content" }
const _hoisted_3 = { class: "tl-sidebar-right" }
const _hoisted_4 = { class: "axero-widget axero-widget-wiki-search" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "axero-widget-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Search")
], -1 /* HOISTED */))
const _hoisted_6 = { class: "tl-widget-content" }
const _hoisted_7 = { class: "axero-widget axero-widget-wiki-tree" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "axero-widget-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Pages")
], -1 /* HOISTED */))
const _hoisted_9 = { class: "tl-widget-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_wiki_search = _resolveComponent("wiki-search")!
  const _component_wiki_tree_item = _resolveComponent("wiki-tree-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_wiki_search)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_wiki_tree_item, { wiki: _ctx.wikiTree }, null, 8 /* PROPS */, ["wiki"])
        ])
      ])
    ])
  ]))
}